<div class="col-md-12">
    <!--<h2>BunnyCRM Support</h2>-->
    <p>BunnyCRM Support is the helpdesk built into BunnyCRM — customer inquiries, tickets, and self-service
        in one place, on the same contact records sales and marketing already use. No syncing a separate
        helpdesk tool with your CRM just so support knows who they're talking to.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Ticket Management:</strong> Create, assign, and track support tickets from a centralized dashboard.</li>
        <li><strong>Kanban Board:</strong> Visualize tickets as cards grouped by status, dragged from one column to the next as they're worked.</li>
        <li><strong>Calendar View:</strong> See tickets by due date alongside the rest of your team's schedule.</li>
        <li><strong>Knowledge Base:</strong> A self-service knowledge base so customers can find answers without opening a ticket.</li>
        <li><strong>Live Chat:</strong> Real-time support on your website, tied to the same contact record as sales and marketing.</li>
        <li><strong>Automated Responses:</strong> Automated replies to common inquiries to save time and improve response speed.</li>
        <li><strong>Reporting &amp; Analytics:</strong> Track ticket volume, response time, and resolution rate.</li>
    </ul>
</div>
